import { render, staticRenderFns } from "./DrugUpdate.vue?vue&type=template&id=29d97e16"
import script from "./DrugUpdate.vue?vue&type=script&lang=js"
export * from "./DrugUpdate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports